import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Subject } from 'rxjs';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  destroyed$ = new Subject<void>();

  constructor(
    private readonly titleService: Title,
    private readonly renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.updateBodyOverflow();
    this.titleService.setTitle('Polygon Mapping Dashboard');
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  private updateBodyOverflow(): void {
    const isEmbedded = globalThis.self !== globalThis.top;
    this.renderer.setStyle(
      document.body,
      'overflow',
      isEmbedded ? 'hidden' : 'auto'
    );
  }
}
